import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Tabs, Spin } from 'antd'; // Import Spin for preloader
import Settings from './FormSettings';
import Logo from './Logo';
import DraggableTabs from './DraggableTabs';
import FieldsWrapper from './FieldsPanel';
import { ActionsReq } from './ActionsReq';
import { DEFAULT_TAB_ID } from './actionsDataJSON';
import ReportTemplateText from './components/ReportTemplateText';
import AccessSettings from './components/AccessSettings';
import { ManageActionFields } from './ManageActionFields';
// FormArchieveReadOnly - ratings and icons now fetched in TopLevelState via readRatings/readIcons and stored in redux
// import Ratings from '../DAL/Ratings';
// import Icons from '../DAL/Icons';
import { useLocation } from 'react-router-dom';
import Organizations from '../DAL/Organizations';

function FormEdit({ ratingsData, iconsData }) {
  const location = useLocation();
  const [defaultTabId, setDefaultTabId] = useState(DEFAULT_TAB_ID);
  const [title, setTitle] = useState('');
  const { TabPane } = Tabs;
  // FormArchieveReadOnly - ratingsData and iconsData come from redux store
 
  const [loading, setLoading] = useState(false); // State for preloader
  const [organization, setOrganization] = useState([]);

  console.log('FormEdit - ratingsData:', ratingsData);
  console.log('FormEdit - iconsData:', iconsData);

  const handleTabChange = (tabId) => {
    setDefaultTabId(tabId);
    if (tabId === '2') {
      // When the user clicks the "Actions" tab, show loading spinner
      setLoading(true);
      // Simulate a delay or loading time to fetch the data
      setTimeout(() => setLoading(false), 500); // You can adjust the timeout based on your fetch time
    }
  };

  const handleTitleUpdate = (title) => {
    setTitle(title);
  };

  // FormArchieveReadOnly - replaced by redux store data from readRatings/readIcons
  // const ratings = new Ratings();
  // const icons = new Icons();
  // useEffect(() => {
  //   const fetchData = async () => {
  //     const ratingsData = await ratings.getAllRatings();
  //     const iconsData = await icons.getAllIcons();
  //     setRatingsData(ratingsData);
  //     setIconsData(iconsData);
  //   };
  //   fetchData();
  // }, []);


  useEffect(() => {
    const fetchOrganization = async () => {
      const pathParts = location.pathname.split('/');
      const orgIdIndex = pathParts.indexOf('organization') + 1;
      if (orgIdIndex > 0 && pathParts[orgIdIndex]) {
        const orgId = pathParts[orgIdIndex];
        const orgModel = new Organizations();
        const orgData = await orgModel.get(orgId);
        setOrganization(orgData.data);
      }
    };
    fetchOrganization();
  }, [location]);
  return (
    <div className="padding-2 flex-column">
      <Tabs defaultActiveKey="1" onChange={handleTabChange}>
        <TabPane tab={title} key="1">
          <Settings handleTitleUpdate={handleTitleUpdate} />
          <Logo />
          <DraggableTabs />
          <FieldsWrapper />
        </TabPane>
        <TabPane tab="Ratings and Icons" key="3">
          <ManageActionFields
            ratingsData={ratingsData}
            iconsData={iconsData}
          />
        </TabPane>
        <TabPane tab="Actions" key="2">
          {loading ? (
            <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '20px' }}>
              <Spin size="large" /> {/* Show spinner while loading */}
            </div>
          ) : (
            <ActionsReq
              ratingsData={ratingsData}
              iconsData={iconsData}
              setRatingsData={()=> {}}
              setIconsData={() => {}}
            />
          )}
        </TabPane>
        <TabPane tab="Report Template" key="4">
          <ReportTemplateText />
        </TabPane>
        {organization && organization[0]?.allow_special_registration && <TabPane tab="Access" key="5">
          <AccessSettings />
        </TabPane>}
      </Tabs>
    </div>
  );
}

const mapStateToProps = (state) => ({
  ratingsData: state.ratings,
  iconsData: state.icons,
})

export default connect(mapStateToProps)(FormEdit)
